import { render, staticRenderFns } from "./MopCopyButton.vue?vue&type=template&id=f7e5bdf2&"
import script from "./MopCopyButton.vue?vue&type=script&lang=js&"
export * from "./MopCopyButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports